<script lang="typescript">
    import { onDestroy, onMount } from "svelte";
    import { slide } from "svelte/transition";
    import * as AppBarSystem from "./systems/app-bar.system";
    import MenuItem from "./menu-item.svelte";
    import Headline6 from "./typography/headline6.svelte";

    let title = AppBarSystem.title;
    // export let accountSubtitle = "account@account.com";

    let state: AppBarSystem.AppBarState = AppBarSystem.getState();
    let leftItems: AppBarSystem.IMenuItem[] = AppBarSystem.getItems();

    const onSystemChange = () => {
        state = AppBarSystem.getState();
        leftItems = AppBarSystem.getItems();
        title = AppBarSystem.title;
    };

    onMount(() => {
        AppBarSystem.onChange.subscribe(onSystemChange);
    });

    onDestroy(() => {
        AppBarSystem.onChange.unsubscribe(onSystemChange);
    });
</script>

{#if state === "show"}
    <menu class="app-bar" transition:slide|local>
        <ul>
            {#each leftItems as item, i (i)}
                <MenuItem
                    on:click={() => item.action && item.action(i)}
                    {item}
                />
            {/each}
        </ul>
        <Headline6 text={title} />
    </menu>
{/if}

<style>
    :root {
        --app-bar-bg: var(--color-level-2, #353535);
    }

    .app-bar {
        /* ☁️ Elevation */
        display: flex;
        flex-direction: row;
        align-items: center;
        background: var(--app-bar-bg);
        width: 100%;
        height: 56px;
        min-height: 56px;
        box-shadow: 0px 4px 5px rgb(0 0 0 / 14%), 0px 1px 10px rgb(0 0 0 / 12%),
            0px 2px 4px rgb(0 0 0 / 20%);
        z-index: 200;
        padding: 16px;
    }
</style>
